import config from '@config';
import { Instance, AexResponseOptions } from 'types';
import { AexResponse } from '@components/AexResponse';
import { log } from './logger';

const STORAGE_KEY = 'AexResponse';

type StoredAexResponse = AexResponseOptions & {
	searchUrl?: string;
};

export function saveAexResponse(
	response: AexResponseOptions,
	instance: Instance,
): void {
	const selector = instance.searchContainer || instance.searchForm;

	if (!selector) {
		return;
	}

	const storedResponse: StoredAexResponse = {
		...response,
		searchUrl: window.location.href,
	};

	sessionStorage.setItem(
		`${STORAGE_KEY}-${selector}`,
		JSON.stringify(storedResponse),
	);
}

export function deleteAexResponse(selector: string): void {
	sessionStorage.removeItem(`${STORAGE_KEY}-${selector}`);
}

export function getAexResponse(
	instance: Instance,
): StoredAexResponse | undefined {
	const selector = instance.searchContainer || instance.searchForm;

	if (!selector) {
		return;
	}

	const raw = sessionStorage.getItem(`${STORAGE_KEY}-${selector}`);

	if (!raw) {
		return;
	}

	try {
		const data = JSON.parse(raw);
		return data;
	} catch {
		log('Something went wrong fetching sessionStorage data');
	}
}

export async function restoreAexResponse(instance: Instance) {
	const selector = instance.searchContainer || instance.searchForm;

	if (!selector) {
		return;
	}

	const raw = sessionStorage.getItem(`${STORAGE_KEY}-${selector}`);

	if (!raw) {
		return;
	}

	function isPersistAllowed(storedResponse: any): boolean {
		const persistConfig = config.persistResults;

		if (!persistConfig) {
			return false;
		}

		if (persistConfig === 'atSource') {
			return storedResponse?.searchUrl === window.location.href;
		}

		if (persistConfig === 'everywhere' || persistConfig === 'atSource' && storedResponse?.searchUrl === window.location.href) {
			return true;
		}

		return false;
	}

	try {
		const data: StoredAexResponse = JSON.parse(raw);

		if (!isPersistAllowed(data)) {
			return;
		}

		data.restored = true;
		data.storageSelector = selector;

		await AexResponse(data);
	} catch {
		log('Something went wrong restoring sessionStorage data');
	}
}
